<template>
	<div class="list-layout">
		<header>
			<div class="title">
				<slot name="title">
					<h1 v-text="title" />
				</slot>
				<slot name="button">
					<Button primary @click="$emit('click', $event)">
						{{ buttonText }}
					</Button>
				</slot>
			</div>

			<slot name="search">
				<Input
					class="search-bar"
					v-model="query"
					:placeholder="placeholder"
					:icon="SearchIcon"
					:iconProps="{ type: 'regular' }"
					allowClear
				/>
			</slot>

			<slot name="custom" />
		</header>

		<slot name="table" />
	</div>
</template>

<script>
import { markRaw } from 'vue'
import { Input, Button } from '@/components/common'
import { SearchIcon } from '@/icons'

export default {
	name: 'ListLayout',
	components: { Input, Button },
	props: {
		title: String,
		buttonText: String,
		placeholder: String,
	},
	data() {
		return { SearchIcon: markRaw(SearchIcon), query: null }
	},
	emits: ['click', 'search'],
	watch: {
		query(query) {
			this.$emit('search', query)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

$header-height: 160px;

.list-layout {
	background: #f9f9f9;
	header {
		height: $header-height;
		@include flex-column;
		padding: 24px;
		.title {
			@include flex-spread;
			margin: 0 0 24px 0;
			h1 {
				font-family: Avenir-Heavy;
				font-size: 36px;
				margin: 0;
				color: var(--neutral-800);
			}
		}
		:deep(.pronto-input),
		:deep(.dropdown-selected) {
			background: white;
		}
	}
}
</style>
